"use client";

import Link from "next/link";

type BreadcrumbDetailsProps = {
  pageName: string;
  description: string;
};

export default function BreadcrumbDetails({
  pageName,
  description,
}: BreadcrumbDetailsProps) {
  return (
    <>
      <div
        className="-mx-4 flex flex-wrap items-center">
        <div className="w-full px-4 md:w-8/12 lg:w-7/12">
          <div className="mb-8 max-w-[570px] md:mb-0 lg:mb-12">
            <h1 className="mb-5 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-700 bg-clip-text text-3xl font-bold text-transparent sm:text-4xl">
              {pageName}
            </h1>
            <p className="text-base leading-relaxed text-gray-600 dark:text-gray-300">
              {description}
            </p>
          </div>
        </div>

        <div className="w-full px-4 md:w-4/12 lg:w-5/12">
          <div className="text-start md:text-end">
            <ul className="flex items-center text-sm md:justify-end">
              <li className="flex items-center">
                <Link
                  href="/"
                  className="text-gray-500 transition hover:text-blue-500"
                >
                  Home
                </Link>
                <span className="mx-2 block h-2 w-2 rotate-45 border-t-2 border-r-2 border-gray-400"></span>
              </li>
              <li className="font-medium text-blue-600">{pageName}</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
